<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 12,
      height: 12,
      color: 'currentColor',
      viewBoxValue: `0 0 12 12`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M6.00005 7.5C4.41501 7.5 3.00545 8.26532 2.10804 9.45298C1.9149 9.7086 1.81833 9.83641 1.82149 10.0091C1.82393 10.1426 1.90773 10.3109 2.01273 10.3933C2.14864 10.5 2.33698 10.5 2.71366 10.5H9.28643C9.66311 10.5 9.85145 10.5 9.98736 10.3933C10.0924 10.3109 10.1762 10.1426 10.1786 10.0091C10.1818 9.83641 10.0852 9.7086 9.89205 9.45298C8.99465 8.26532 7.58509 7.5 6.00005 7.5Z"
      fill="currentColor"
    />
    <path
      d="M6.00005 6C7.24269 6 8.25005 4.99264 8.25005 3.75C8.25005 2.50736 7.24269 1.5 6.00005 1.5C4.75741 1.5 3.75005 2.50736 3.75005 3.75C3.75005 4.99264 4.75741 6 6.00005 6Z"
      fill="currentColor"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
